import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DNS,
  integrations: [new Integrations.Vue({Vue, attachProps: true})]
});

Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        accent: '#0f6eb2',
        background: '#EEEEEE',
        info: '#87ceeb'
      },
    },
  }
});
